import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import "moment-timezone";
import IconBool from "../../../components/IconBool";

const PrevProgramming = ({show, item}) => {
    const [tc] = useTranslation("choices");
    const {t: tT} = useTranslation("tables");

    return (
        <div
            className={`col preview-row ${show ? "" : "d-none"}`}
            style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="clipboard" />
                            </div>
                            <div className="preview-title">
                                <label>{tT("common.name")}</label>
                                <div>{item.name}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("common.description")}</label>
                            <div className="preview-input">{item.description}</div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("common.type")}</label>
                            <div className="preview-input">
                                {tc("programming." + item.type)}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("programming.dates")}</label>
                            <div className="preview-input">
                                {item.date_start ? moment(item.date_start).format("DD-MM-YYYY") : " - "}
                                &nbsp;/&nbsp;
                                {item.date_end ? moment(item.date_end).format("DD-MM-YYYY") : " - "}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("programming.hours")}</label>
                            <div className="preview-input">
                                {item.compile ? (moment(item.compile, "HH:mm:ss").format("HH:mm")) : " - "}
                                &nbsp;/&nbsp;
                                {item.run ? (moment(item.run, "HH:mm:ss").format("HH:mm")) : " - "}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("programming.periodic")}</label>
                            <div className="preview-input">
                                <IconBool value={item.is_periodic} />
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("programming.tasks")}</label>
                            <div className="preview-input">
                                {Array.isArray(item.tasks) && item.tasks.length > 0
                                    ? item.tasks.map((t) => t.name).join(", ")
                                    : " - "}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tT("programming.periodic")}</label>
                            <div className="preview-input">
                                {item.is_periodic ? `${item.every} ${tT("repeat." + item.repeat)}` : "No"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevProgramming;
